import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetNewsTable } from '../../api/Queries/get';
import { Context } from '../../Store/context';
import Loading from '../../Component/loader/loader';
import { DateRangeOutlined } from '@mui/icons-material';
import layoutBgImg from '../../Images/layout/news.jpg'
import GlobalLayout from '../../Component/layout/global-layout';
import { Get } from '../../api/services/api_helpers';

const NewsTable = () => {
  const [globalNews, setGlobalNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [newsTable, setNewsTable] = useState([])
  const location = useLocation().pathname.split('/')[2];
  const { i18n, t } = useTranslation();
  const { showError } = useContext(Context);

  useEffect(() => {
    setIsLoading(true)
    const getNews = async () => {
      try {
        const globalData = await Get(`news/?category=global`);
        setGlobalNews(globalData.results);
        setIsLoading(false)
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getNews()
  }, [showError])


  useEffect(() => {
    const getNewsTable = async () => {
      try {
        const res = await GetNewsTable(location)
        setNewsTable(res.data)
      } catch (error) {
        showError(error.message);
      }
    }
    getNewsTable()
  }, [location, showError])

  const categoryTitle = () => {
    if (newsTable?.category === 'global') {
      return t('country_news');
    } else if (newsTable?.category === 'local') {
      return t('judicial_news');
    } else {
      return t('article');
    }
  };

  const getNewsCategory = (news) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return news?.rus_name;
    } else if (currentLang === 'en') {
      return news?.eng_name;
    }
    return news?.tm_name;
  };

  const getNewsSource = (news) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return news?.rus_source;
    } else if (currentLang === 'en') {
      return news?.eng_source;
    }
    return news?.tm_source;
  };


  const getNewsContent = (news) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return news?.rus_content;
    } else if (currentLang === 'en') {
      return news?.eng_content;
    }
    return news?.tm_content;
  };

  const getAllNewsName = (news) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return news?.rus_name;
    } else if (currentLang === 'en') {
      return news?.eng_name;
    }
    return news?.tm_name;
  };

  const getAllNewsCategory = (news) => {
    if (news?.category === 'global') {
      return t('country_news');
    } else if (news?.category === 'local') {
      return t('judicial_news');
    } else {
      return t('article');
    }
  };

  return (
    <GlobalLayout
      title={`${categoryTitle()} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords=""
    >
      <div className='mb-20'>
        <Layout
          title={categoryTitle()}
          layoutBgImg={layoutBgImg}
        />
        <div className='mt-8 px-4 dark:text-dark-text xxl:px-12
                      xxxl:px-32 xxxxl:px-64 xxxxxl:px-[400px] 
                      xxxxxxl:px-[650px] xxxxxxxl:px-[1600px] 
                      xxxxxxxxl:px-[2400px]'>

          <p className='mb-6 font-bold text-primary 
                     dark:text-white text-xl'>
            {getNewsCategory(newsTable)}
          </p>
          <div className='xl:flex xl:justify-between gap-8 h-max'>
            <section className='xl:w-[68%]'>
              <img
                src={newsTable?.photo}
                alt="news"
                className='object-contain w-full'
              />
              <span className='block my-4 text-blackOpacity 
                             flex gap-1 dark:text-dark-text'>
                <DateRangeOutlined style={{ fontSize: '20px', marginBottom: '2px' }} />
                {newsTable?.date}
              </span>
              <div className="text-justify mb-4">
                {/* {getNewsContent(newsTable)?.split('\n').map((paragraph, index) => (
                <p key={index} className='leading-loose'>
                  {paragraph}
                </p>
              ))} */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: document ?
                      getNewsContent(newsTable) : ''
                  }}
                  className='leading-loose'
                />
              </div>
              {getNewsSource(newsTable) ?
                <div className='flex gap-4 text-primary dark:text-white my-4'>
                  <a href={newsTable.source_link}>
                    {getNewsSource(newsTable)}
                  </a>
                </div> : ''
              }
            </section>

            <section className='xl:w-[30%] p-8 h-max max-h-[875px]
                          dark:border-dark-border dark:bg-dark-box
                          dark:text-dark-text bg-white'>
              <h2 className='text-xl font-semibold mb-2 text-primary'>
                {t('last_news')}
              </h2>
              <ul className='news space-y-2 overflow-y-scroll h-max max-h-[800px]'>
                {isLoading ? <Loading /> : <>
                  {globalNews?.map((news, index) => (
                    <li
                      key={index}
                      className='py-2 pr-4 border-b border-b-secondary
                               dark:border-dark-border'
                    >
                      <ul>
                        <li className='font-bold mb-2'>
                          {news.date} / {getAllNewsCategory(news)}
                        </li>
                        <li className='text-text dark:text-dark-text'
                          style={{ fontSize: '14px' }}
                        >
                          {getAllNewsName(news)}
                        </li>
                      </ul>
                    </li>
                  ))}
                </>}
              </ul>
            </section>
          </div>

        </div>
      </div>
    </GlobalLayout>
  )
}

export default NewsTable